import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PartnershipListBlock}
 */
const PartnershipList = ({
    backgroundColor,
    partners,
    text,
    title
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg py-24`}>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            {text && (
                <p className='col-padding type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-6/12'>
                    {text}
                </p>
            )}

            <div className='flex flex-wrap gap-y-10 mt-24'>
                {partners.map((partner) => {
                    return (
                        <div
                            className='w-full sm:w-6/12 flex flex-wrap'
                            key={partner.id}>
                            <div className='col-padding w-full sm:w-5/6'>
                                <div className='py-16 border-t border-border-default'>
                                    <p className='type-style-sans-h3-med'>
                                        {partner.title}
                                    </p>

                                    {partner.text && (
                                        <p className='type-style-sans-body mt-8'>
                                            {partner.text}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className='hidden sm:block w-1/6'/>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipList;
